<template>
    <div class="wrapper presentation-page">
        <div class="page-header clear-filter">
          
            <!-- IMAGEN DE FONDO PARALLAX PRIMER BLOQUE PRINCIPAL (INCLUYE MENU SUPERIOR) -->
            <div class="rellax-header rellax-header-sky">
                <!-- EN LA IMAGEN ES EL OPERARIO REPARTIENDO POR EL ALMACEN CON LA SEGWAY -->
                <parallax class="page-header-image"
                  v-bind:style="{ backgroundImage: 'url(' + mensaje('img1') + ')' }">
                </parallax>
            </div>
            
            <!-- ESTE BLOQUE SACA TITULO ALLBOX (DEGRADADO) Y A LA DERECHA EN PEQUEÑO "Manager" -->
            <div class="rellax-text-container rellax-text">
              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-500%,530%);">principal.json->mensajes:img1</span>
                <h1 class="h1-seo" data-rellax-speed="-2" v-bind:style="estiloback">{{mensaje('tit1')}}</h1>
                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-20%,-310%);">principal.json->mensajes:tit1</span><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-30%,-450%);">COLOR DEGRADADO<br>principal.json->mensajes:color-origen-titulo<br>principal.json->mensajes:color-fin-titulo</span>
                <div class="pro" v-if="mensaje('tit2activo')==true">{{mensaje('tit2')}}</div><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(280%,-690%);">[principal.json->mensajes:tit2]</span>
            </div>
            
            <!-- ESTO SACA DEBAJO DEL TITULO GRANDE Web de la aplicación All Box Manager..... -->
            <h3 class="h3-description rellax-text" data-rellax-speed="-1">{{mensaje('tit3')}}</h3><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(580%,690%);">principal.json->mensajes:tit3</span>
            <h6 class="category category-absolute rellax-text" data-rellax-speed="-2">
                <parallax>
                    <!-- ESTO SACABA AL PIE DEL PARALLAX LOS CREDITOS DE CEESA, PODRIAMOS PARAMETRIZAR PARA LA DEMO -->
                    <!--
                    Desarrollado para 
                    <a href="https://allboxmanager.com" target="_blank">
                      <img v-lazy="'img/ALLBOXManager512x512.png'" class="allbox-logo" alt=""/>
                    </a> 
                    por:&nbsp;
                    <a href="https://ceesa.com" target="_blank">
                        <img v-lazy="'img/LogoCEESAslimWhite.png'" class="creative-tim-logo" alt=""/>
                    </a>
                    -->
                </parallax>
            </h6>
          
        </div>
        
        <!--     *********     FEATURES 3      *********  
        <div class="features-3" data-background-color="dark-red">
        <div class="features-3" data-background-color="black">    
        -->
        <div class="features-3">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h2 class="title">{{mensaje('tit4')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit4</span></h2>
                        <h4 class="description" v-html="mensaje('men4')"></h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men4 <i>HTML</i></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!--<div class="info info-hover">-->
                        <div class="info">
                            <div class="icon icon-success icon-circle">
                                <i class="now-ui-icons" v-bind:class="mensaje('ico5')"></i><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,130%);">principal.json->mensajes:ico5</span>
                            </div>
                            <h4 class="info-title">{{mensaje('tit5')}}</h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit5</span>
                            <p class="description" v-html="mensaje('men5')"></p><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men5 <i>HTML</i></span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info">
                            <div class="icon icon-info icon-circle">
                                <i class="now-ui-icons" v-bind:class="mensaje('ico6')"></i><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,130%);">principal.json->mensajes:ico6</span>
                            </div>
                            <h4 class="info-title">{{mensaje('tit6')}}</h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit6</span>
                            <p class="description" v-html="mensaje('men6')"></p><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men6 <i>HTML</i></span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons" v-bind:class="mensaje('ico7')"></i><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,130%);">principal.json->mensajes:ico7</span>
                            </div>
                            <h4 class="info-title">{{mensaje('tit7')}}</h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit7</span>
                            <p class="description" v-html="mensaje('men7')"></p><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men7 <i>HTML</i></span>
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                      <div class="info">
                          <div class="icon icon-success icon-circle">
                              <i class="now-ui-icons" v-bind:class="mensaje('ico8')"></i><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,130%);">principal.json->mensajes:ico8</span>
                          </div>
                          <h4 class="info-title">{{mensaje('tit8')}}</h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit8</span>
                          <p class="description" v-html="mensaje('men8')"></p><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men8 <i>HTML</i></span>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="info">
                          <div class="icon icon-info icon-circle">
                              <i class="now-ui-icons" v-bind:class="mensaje('ico9')"></i><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,130%);">principal.json->mensajes:ico9</span>
                          </div>
                          <h4 class="info-title">{{mensaje('tit9')}}</h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit9</span>
                          <p class="description" v-html="mensaje('men9')"></p><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men9 <i>HTML</i></span>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="info">
                          <div class="icon icon-primary icon-circle">
                              <i class="now-ui-icons" v-bind:class="mensaje('ico10')"></i><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,130%);">principal.json->mensajes:ico10</span>
                          </div>
                          <h4 class="info-title">{{mensaje('tit10')}}</h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit10</span>
                          <p class="description" v-html="mensaje('men10')"></p><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men10 <i>HTML</i></span>
                      </div>
                  </div>
              </div>
                
            </div>
        </div>
        <!--     *********    END FEATURES 3      *********      -->
  
  
        <!--     *********    PRICING 3     *********      -->
        <div class="pricing-3 section-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img2') + ')' }" id="pricing-3">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 ml-auto mr-auto text-center">
                        <h2 class="title">{{mensaje('tit11')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit11</span></h2>
                        <h4 class="description" v-html="mensaje('men11')"></h4><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:men11 <i>HTML</i></span>
                        <div class="section-space"></div>
                    </div>
                </div>
                <div class="row">
                  
                  <div class="col-md-4 mr-auto ml-auto" v-for="modulo in modulos">
                    <card type="pricing" raised :color="modulo.color">
                        <h6 class="category">{{modulo.tipo}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->modulos[]:tipo</span></h6>
                        <h1 class="card-title">
                            <small>{{modulo.prefijo}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,150%); width: 180px; line-height: normal;">principal.json->modulos[]:prefijo</span></small>
                            {{modulo.precio}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,150%); width: 180px; line-height: normal;">principal.json->modulos[]:precio</span>
                            <small>{{modulo.sufijo}}</small><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-30%,150%); width: 180px; line-height: normal;">principal.json->modulos[]:sufijo</span>
                        </h1>
                        <ul>
                            <li>{{modulo.lin1}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->modulos[]:lin1</span></li>
                            <li>{{modulo.lin2}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->modulos[]:lin2</span></li>
                            <li>{{modulo.lin3}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->modulos[]:lin3</span></li>
                            <li>{{modulo.lin4}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->modulos[]:lin4</span></li>
                        </ul>
                        <n-button type="neutral" round @click.native="contratar(modulo.link)" v-if="nosotros.reservas==true">{{modulo.boton}}</n-button><span v-if="$store.state.editor==true" class="texto-editor2">principal.json->modulos[]:boton</span>
                    </card>
                  </div>                
                  
                  
                  
                  <!--<div class="col-md-4 ml-auto">
                      <card type="pricing">
                          <h6 class="category">Freelance</h6>
                          <h1 class="card-title">
                              <small>$</small>
                              29
                              <small>/mo</small>
                          </h1>
                          <ul>
                              <li>1 GB of space</li>
                              <li>Limited Support</li>
                              <li>Support at $25/hour</li>
                              <li>Limited cloud access</li>
                          </ul>
                          <n-button type="primary" round>Get Started</n-button>
                      </card>
                  </div>-->


                    
                </div>
            </div>
        </div>
        <!--     *********    END PRICING 3      *********      -->      


        <!--     *********    CONTACT US 2     *********      -->
        <div class="contactus-2">
            <gmap-map
                    id="map"
                    class="map"
                    :center="center"
                    :zoom="16"
                    :options="options"
                    map-type-id="roadmap" v-if="renderComponent">
                <gmap-marker :position="center">
                </gmap-marker>
            </gmap-map>
            <div class="col-lg-6 col-md-10">
                
                <card type="contact" raised header-classes="text-center">
                  <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(350%,550%); width: 220px; line-height: normal;">principal.json->nosotros:center:lat y lng</span>
                    <h4 slot="header" class="card-title">{{mensaje('tit12')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit12</span></h4>
        
        
                    <div class="row">
                        <div class="col-md-6">
                            <info-section type="primary"
                                         icon="now-ui-icons tech_mobile">
                                <h5 class="info-title">{{mensaje('tit13')}}</h5><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">principal.json->mensajes:tit13</span>
                                <p> {{nosotros.empresa}}<br><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-70%); line-height: normal;">principal.json->nosotros:empresa</span>
                                     {{nosotros.telefono}}<br><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-70%); line-height: normal;">principal.json->nosotros:telefono</span>
                                     {{nosotros.horario}}<br><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-70%); line-height: normal;">principal.json->nosotros:horario</span>
                                </p>
                            </info-section>
                        </div>
                        <div class="col-md-6">
                            <info-section type="primary"
                                          icon="now-ui-icons location_pin">
                                <h5 class="info-title">{{mensaje('tit14')}}</h5><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-100%); line-height: normal;">principal.json->mensajes:tit14</span>
                                <p> {{nosotros.direccion}}<br><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-70%); line-height: normal;">principal.json->nosotros:direccion</span>
                                     {{nosotros.cp}} {{nosotros.poblacion}}<br><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-70%); line-height: normal;">principal.json->nosotros:poblacion</span>
                                     {{nosotros.provincia}}<br><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-70%); line-height: normal;">principal.json->nosotros:provincia</span>
                                </p>
                            </info-section>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Nombre -->
                        <div class="col-md-6 pr-2">
                            <label>{{mensaje('tit15')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit15</span></label>
                            <fg-input
                                    v-model="crm.nombre"
                                    :placeholder="mensaje('tit19')"
                                    addon-left-icon="now-ui-icons users_circle-08">
                            </fg-input>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(50%,-150%); line-height: normal;">principal.json->mensajes:tit19</span>
                        </div>
                        <!-- Teléfono -->
                        <div class="col-md-6 pl-2">
                            <label>{{mensaje('tit23')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit23</span></label></label>
                            <fg-input
                                    v-model="crm.telefono"
                                    :placeholder="mensaje('tit24')"
                                    addon-left-icon="now-ui-icons tech_mobile">
                            </fg-input>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(50%,-150%); line-height: normal;">principal.json->mensajes:tit24</span>
                        </div>
                        <!-- Correo Electrónico -->
                        <div class="col-md-12 pl-2">
                            <label>{{mensaje('tit16')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit16</span></label></label>
                            <fg-input
                                    v-model="crm.email"
                                    :placeholder="mensaje('tit20')"
                                    addon-left-icon="now-ui-icons ui-1_email-85">
                            </fg-input>
                            <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(50%,-150%); line-height: normal;">principal.json->mensajes:tit20</span>
                        </div>
                        <!-- Tu mensaje -->
                        <div class="col-md-12 pl-2">
                            <label>{{mensaje('tit25')}}<span v-if="$store.state.editor==true" class="texto-editor2">principal.json->mensajes:tit25</span></label></label>
                            <textarea 
                              v-model="crm.comentario"
                              name="message" 
                              class="form-control" 
                              id="message" 
                              rows="6">
                            </textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <n-checkbox v-model="crm.check">
                                {{mensaje('tit17')}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-40%,-10%); line-height: normal; width: 170px;">principal.json->mensajes:tit17</span>
                            </n-checkbox>
                        </div>
                        <div class="col-md-6">
                            <n-button type="primary" round @click.native="enviacrm" class="pull-right">{{mensaje('tit18')}}</n-button><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(50%,-10%); line-height: normal; width: 170px;">principal.json->mensajes:tit18</span>
                        </div>
                    </div>
                    
        
                </card>
            </div>
        </div>
        <!--     *********    END CONTACT US 2      *********      -->
        
        
      
      <modal :show.sync="dialogVisible" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">{{mensaje('men20')}}</h4>
        <p>{{mensaje('men21')}}</p>
        <template slot="footer">
          <n-button type="primary" @click.native="dialogVisible = false">{{mensaje('men22')}}</n-button>
        </template>
      </modal>
      
      <modal :show.sync="dialogVisible2" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">{{mensaje('men23')}}</h4>
        <p>{{mensaje('men24')}}</p>
        <template slot="footer">
          <n-button type="primary" @click.native="dialogVisible2 = false">{{mensaje('men22')}}</n-button>
        </template>
      </modal>
      
      <modal :show.sync="dialogVisible3" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">{{mensaje('men25')}}</h4>
        <p>{{mensaje('men26')}}</p>
        <template slot="footer">
          <n-button type="primary" @click.native="dialogVisible3 = false">{{mensaje('men22')}}</n-button>
        </template>
      </modal>
      
      

        <div class="section section-pricing" id="sectionBuy">
            <div class="container">
              
              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(40%,100%); line-height: normal;">MENSAJES DE RESPUESTA DE EVENTOS</span>
              <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(19%,200%); line-height: normal;">principal.json->mensajes:men20, men21, men22, men23, men24, men25, men26</span>

                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">{{mensaje('tit21')}}</h2><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-50%,-150%); line-height: normal; width: 170px;">principal.json->mensajes:tit21</span>
                    </div>

                    <div class="text-center col-md-8 ml-auto mr-auto" v-if="mensaje('redesactivo')==true">
                        <h3>{{mensaje('tit22')}}</h3><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-50%,-150%); line-height: normal; width: 170px;">[principal.json->mensajes:tit22]</span>
                    </div>
                    <div class="text-center col-md-8 ml-auto mr-auto" v-if="mensaje('redesactivo')==true">
                        <a :href="mensaje('lnk1')" class="btn btn-icon btn-lg btn-round btn-twitter twitter-sharrre sharrre"
                           rel="tooltip" title="" data-original-title="Tweet!" v-if="mensaje('lnk1activo')==true">
                            <i class="fab fa-twitter"></i>
                        </a><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,150%); line-height: normal; width: 170px;">[principal.json->mensajes:lnk1]</span>
                        <a :href="mensaje('lnk2')" class="btn btn-lg btn-round btn-icon btn-facebook facebook-sharrre sharrre"
                           rel="tooltip" title="" data-original-title="Share!" v-if="mensaje('lnk2activo')==true">
                            <i class="fab fa-facebook-square"></i>
                        </a><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-70%,-30%); line-height: normal; width: 170px;">[principal.json->mensajes:lnk2]</span>
                        <a :href="mensaje('lnk3')" class="btn btn-lg btn-round btn-icon btn-linkedin linkedin-sharrre sharrre"
                           rel="tooltip" title="" data-original-title="Share!" v-if="mensaje('lnk3activo')==true">
                            <i class="fab fa-linkedin"></i>
                        </a><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-35%,150%); line-height: normal; width: 170px;">[principal.json->mensajes:lnk3]</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { Card, InfoSection, Button, Tabs, TabPane, FormGroupInput, Checkbox, Modal } from '@/components';
  import { Carousel, CarouselItem, Tooltip, Notification } from 'element-ui'
  import {RUTA_BASE} from '@/constants'
  import {RUTA_PHP} from '@/constants'

  import axios from "axios"
  //import {API_KEY} from '@/constants'
  
  import Vue from 'vue'
  
  export default {
    name: 'principal',
    bodyClass: 'presentation-page',
    components: {
      Modal,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Notification.name]: Notification,
      Tabs,
      TabPane,
      [Button.name]: Button
    },
    props: {
      pago: {
        type: String,
        default: '' // Valor predeterminado si `pago` es undefined
      }
    },
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        renderComponent: false,
        headerSimple: false,
        estiloback: {
          background: this.colorback1,
          background: this.colorback2,
          background: this.colorback3,
        },
        colorback1: '',
        colorback2: '',
        colorback3: '',
        mensajes: [],
        modulos: [],
        nosotros: {},
        entorno: '',
        crm: {
          nombre: '',
          email: '',
          comentario: '',
          telefono: '',
          check: false
        },
        center: {
          lat: 43.321485,
          lng: -3.012901
        },
        options: {
          styles: [{
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
              "color": "#e9e9e9"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 29
            }, {
              "weight": 0.2
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 18
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 21
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
              "color": "#dedede"
            }, {
              "lightness": 21
            }]
          }, {
            "elementType": "labels.text.stroke",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "elementType": "labels.text.fill",
            "stylers": [{
              "saturation": 36
            }, {
              "color": "#333333"
            }, {
              "lightness": 40
            }]
          }, {
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f2f2f2"
            }, {
              "lightness": 19
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 17
            }, {
              "weight": 1.2
            }]
          }]
        
        }
        
        
        
        
      }
    },
    
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
    },
    
    
    computed: {
      gradientStyles() {
        return {
          background: `${this.colorback1}, ${this.colorback2}, ${this.colorback3}`
        };
      }
    },


    methods: {
      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/principal'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
            this.mensajes = response.data.mensajes
            this.modulos = response.data.modulos
            this.nosotros = response.data.nosotros
            this.center.lat = parseFloat(this.nosotros.center.lat)
            this.center.lng = parseFloat(this.nosotros.center.lng)
            console.log(this.nosotros.center)
            this.renderComponent = true
        })
        .catch(error => console.log(error))
      },
      contratar(link) {
        this.$router.push('/'+link)
      },
      
      mensaje(nom) {
        var mens = ''
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      },
      enviacrm() {
        if (this.crm.check==true) {
          var params = new URLSearchParams()
          params.append('nombre',this.crm.nombre)
          params.append('email', this.crm.email)
          params.append('comentario', this.crm.comentario)
          params.append('telefono', this.crm.telefono)
          axios.post(RUTA_PHP+'tomacrm.php', params)
          .then((respuesta) => {
              if (typeof respuesta.data !== 'undefined' && respuesta.data.length > 0) {
                var resp = respuesta.data
                console.log(resp)
                if (resp.includes("CORRECTO")) {
                  console.log('correcto')
                  this.dialogVisible = true
                }
              }
          });
        } else {
        }
      }
    },
    created() {
      var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
      var cadJson = 'json/principal'+numIdioma.toString()+'.json'
      axios.get(RUTA_BASE+cadJson)
      .then(response => {
          this.mensajes = response.data.mensajes
          var colba1 = "-moz-linear-gradient(top, "+this.mensaje('color-origen-titulo')+" 35%, "+this.mensaje('color-fin-titulo')+" 100%)"
          var colba2 = "-webkit-linear-gradient(top, "+this.mensaje('color-origen-titulo')+" 35%, "+this.mensaje('color-fin-titulo')+" 100%)"
          var colba3 = "linear-gradient(to bottom, "+this.mensaje('color-origen-titulo')+" 35%, "+this.mensaje('color-fin-titulo')+" 100%)"
          this.colorback1 = colba1
          this.colorback2 = colba2
          this.colorback3 = colba3
          
          this.estiloback = {
            background: this.colorback1,
            background: this.colorback2,
            background: this.colorback3
          }
          
      })
      .catch(error => console.log(error))
      
    },
    mounted() {
      this.entorno = process.env.NODE_ENV
      
      // Comprobar el estado del pago y mostrar la notificación correspondiente
      if (this.pago === 'ok') {
        Notification.info({
          title: 'Correcto',
          message: 'El pago ha sido correcto'
        });
      } else if (this.pago === 'ko') {
        Notification.error({
          title: 'Error',
          message: 'El pago no ha podido realizarse'
        });
      }

      
      // COMPROBAMOS SI HAY NUEVA VERSION EN EL CLIENTE PARA FORZAR UN REFRESCO
      /*
      if (localStorage.getItem('allbox-web-version')) {
        if (ALLBOX_WEB_VERSION != localStorage.getItem('allbox-web-version')) {
          var version_old = localStorage.getItem('allbox-web-version')
          localStorage.setItem('allbox-web-version', ALLBOX_WEB_VERSION)
          console.log('Se ha actualizado a la versión: '+ALLBOX_WEB_VERSION+' desde la: '+version_old)
          window.location.reload(true)
        } else {
          console.log('Versión: '+ALLBOX_WEB_VERSION)
        }
      } else {
        console.log('Versión: '+ALLBOX_WEB_VERSION)
        localStorage.setItem('allbox-web-version', ALLBOX_WEB_VERSION)
        window.location.reload(true)
      }
      */
      this.headerSimple = this.$store.state.header_simple
      console.log(RUTA_PHP)
      
      axios.get(RUTA_PHP+'dameboxes.php')
      .then(response => {
          console.log('dameboxes.php: ',response.data)
      })
      .catch(error => console.log(error))

      console.log("idioma: ",this.$idioma)
      var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
      var cadJson = 'json/principal'+numIdioma.toString()+'.json'
      
      /*
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      if (urlParams.has('pago')) {
          //console.log('params pago: ',urlParams.get('pago'))
          if (urlParams.get('pago')=='ok') {
            this.dialogVisible2 = true
          } else {
            this.dialogVisible3 = true
          }
      }
      */

      axios.get(RUTA_BASE+cadJson)
      .then(response => {
          this.mensajes = response.data.mensajes
          this.modulos = response.data.modulos
          this.nosotros = response.data.nosotros
          this.center.lat = parseFloat(this.nosotros.center.lat)
          this.center.lng = parseFloat(this.nosotros.center.lng)
          console.log(this.nosotros.center)
          this.renderComponent = true
      })
      .catch(error => console.log(error))
    }
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
</style>
